import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Modal,
} from 'reactstrap';

import InternalOrderForm from './InternalOrderForm';

function InternalOrderModal(props) {
  const {
    shown, t, order, onClose,
  } = props;

  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setModalOpen(shown);
  }, [order, shown]);

  const onSuccess = (x) => {
    setModalOpen(false);
    props.onSuccess(x);
  };

  const jsx = (
    <Modal
      size="lg"
      isOpen={modalOpen}
    >
      <div className="modal-header">
        <h5
          className="modal-title mt-0"
        >
          {t('Save Order')}
        </h5>
        <button
          onClick={() => { setModalOpen(false); onClose(); }}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <InternalOrderForm entity={order} onSuccess={onSuccess} />
      </div>
      <div className="modal-footer">
        <button
          type="button"
          onClick={() => { setModalOpen(false); onClose(); }}
          className="btn btn-soft-dark"
          data-dismiss="modal"
        >
          {t('Cancel')}
        </button>
        <button
          type="submit"
          form="InternalOrderForm"
          className="btn btn-primary"
        >
          {t('Save')}
        </button>
      </div>
    </Modal>
  );

  return jsx;
}

InternalOrderModal.defaultProps = {
  shown: false,
  onSuccess: () => { },
  order: {},
  onClose: () => {},
};

InternalOrderModal.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  order: PropTypes.object,
  shown: PropTypes.bool,
  onSuccess: PropTypes.func,
  onClose: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(InternalOrderModal));
